import React, { useCallback, useMemo } from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import { connect } from 'react-redux';
import OverviewShell from '../overview_shell/OverviewShell';

const SupplierInvoicesSavedFiltersViewOverviewPage = ({
	childRoutes,
	history,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => {
			history.push(`/supplier/invoices/savedViews/overview/${key}`);
		},
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history]
	);

	const tabs = useMemo(
		() => [
			{
				key: 'all',
				name: 'All',
			},
		],
		[]
	);

	return (
		<>
			<Route
				path="/supplier/invoices/savedViews/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/supplier/invoices/savedViews/overview/all',
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Invoices Saved Views"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = () => ({});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(SupplierInvoicesSavedFiltersViewOverviewPage)
);
